import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'
import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CardBase, * as Card from '@segment/matcha/recipes/Card'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  title: `Focused on collecting customer data? Check out Connections`,
  description: `Get started for free and collect real-time event data from 450+ pre-built sources, including the data warehouse, and send unified customer data to your favorite marketing and analytics tools.`,
  button: {
    text: `View Connection plans`,
    href: `/pricing/connections/`,
  },
}

const content = {
  title: `Connections enables engineering teams to:`,
  benefits: [
    `Collect and unify real-time event data with customer data in the warehouse`,
    `Send customer data to 450+ destinations`,
  ],
}

const OtherOptions = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <StyledSectionBase variant="2Col">
        <Section.Copy>
          <Title variant="h2">{copy.title}</Title>
          <Description variant="pLarge">{copy.description}</Description>
          <Button
            variant="filled"
            color="primary"
            size="medium"
            href={getAbsoluteUrl(copy.button.href, pageConfig)}
            onClick={() =>
              trackButtonClick({
                buttonText: copy.button.text,
                targetUrl: copy.button.href,
                buttonId: `pricing-cdp-page-view-connections-plans`,
              })
            }
          >
            {copy.button.text}
          </Button>
        </Section.Copy>
        <Section.Contents>
          <StyledCardBase>
            <Card.Body>
              <Card.Copy>
                <ListTitle variant="pMediumBold">{content.title}</ListTitle>
                <List>
                  {content.benefits.map((benefit) => (
                    <StyledListItem key={benefit}>
                      <Benefit variant="pMedium">{benefit}</Benefit>
                    </StyledListItem>
                  ))}
                </List>
              </Card.Copy>
            </Card.Body>
          </StyledCardBase>
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1280px;

  ${Section.Wrapper} {
    grid-template-columns: 1fr;
  }
`

const StyledCardBase = styled(CardBase)`
  max-width: 478px;
`

const Title = styled(Typography)`
  margin: 0;
`

const Description = styled(Typography)``
const ListTitle = styled(Typography)`
  margin: 0;
`

const List = styled.ul`
  margin-bottom: 24px;
  padding-left: 24px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    margin-bottom: 0;
  }
`

const StyledListItem = styled.li`
  list-style-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.045.667a.91.91 0 0 1 .025 1.305L5.031 8.126a.95.95 0 0 1-1.356 0L.93 5.33a.91.91 0 0 1 .025-1.305.954.954 0 0 1 1.331.025l2.067 2.106L9.714.692a.954.954 0 0 1 1.33-.025Z' fill='%23121C2D'/%3e%3c/svg%3e ");

  font-weight: 400;
  padding: 0 0 8px 8px;
`

const Benefit = styled(Typography)`
  margin: 0;
  display: flex;
  gap: 8px;
`

export default OtherOptions
